import { getEmptyParagraphNode } from '@doltech/utils/lib/editor';
import { imgProxyLoader } from '@doltech/utils/lib/image-loader';
import Image from 'next/image';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../colors-v2';
import { PreviewDescriptionEditor } from '../../shared/components/DescriptionEditor/View/PreviewDescriptionEditor';

/* eslint-disable react/no-unused-prop-types */
const Main = styled.div.withConfig({
  componentId: 'BlogCover_Main',
} as any)`
  .preview-description-editor {
    margin-top: 8px;
    color: ${colorsV2.black70};
  }
  .image-cover-editor {
    object-fit: contain;
    width: 100%;
  }
  > img {
    max-width: 100%;
    object-fit: contain;
    height: auto;
  }
`;

export interface BlogCoverProps {
  text?: string;

  src: string;
  width?: number;
  height?: number;
  alt: string;
}

export const BlogCoverEditor = (props: BlogCoverProps) => {
  const { width, height, text, src, alt } = props;
  const initialValue = React.useMemo(() => {
    let result: any = [];

    if (!text) {
      return [];
    }
    if (typeof text === 'string') {
      try {
        result = JSON.parse(text);
      } catch (ex) {
        result = getEmptyParagraphNode(text);
      }
    }
    return result;
  }, [text]);

  const renderImage = React.useCallback(() => {
    if (width && height) {
      return (
        <img
          width={width}
          height={height}
          className="image-editor"
          alt={alt || 'blog-cover-editor'}
          src={src}
          title={alt}
        />
      );
    }
    if (src) {
      return (
        <Image
          loader={imgProxyLoader}
          layout="responsive"
          width={3}
          height={2}
          className="image-cover-editor"
          alt={alt || 'blog-cover-editor'}
          src={src}
          title={alt}
          loading="eager"
        />
      );
    }
    return null;
  }, [alt, height, src, width]);

  return (
    <Main id="blog-cover">
      {renderImage()}

      {initialValue?.length > 0 && <PreviewDescriptionEditor initialValue={initialValue} />}
    </Main>
  );
};
